import './WaterlineManagement.css'
import { useState } from 'react'
import { useTheme, Box, Tabs, Tab } from "@mui/material"
import PageHeader from "../../../components/PageHeader"
import WaterlineCalendar from './WaterlineCalendar'
import WaterlineInventory from './WaterlineInventory'
import { waterlineIcon } from "../../../icons"
import { WaterlineCalendarRow, WaterlineCustomer } from './types'
import { Groups } from '../../../types'

type WaterlineManagementProps = {
  customer: WaterlineCustomer | null,
  practices: WaterlineCalendarRow[] | null,
  groups: Groups[],
}

const WaterlineManagement = (props: WaterlineManagementProps) => {
  const theme = useTheme()

  const [tabIndex, setTabIndex] = useState(0)

  const pageTabs = ['Test Results', 'Inventory']

  const handleTabChange: ((event: React.SyntheticEvent, value: any) => void) = (event, newValue) => {
    setTabIndex(newValue)
  }

  const tabPages = [
    <WaterlineCalendar key="0" />,
    <WaterlineInventory key="1" />,
  ]

  return (
    <>
      <PageHeader src={waterlineIcon} headerName={'Waterline Management'} size={'26px'} />
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className={'flex flex-space-between flex-align-center'}>
        <Tabs value={tabIndex} onChange={handleTabChange} aria-label="basic tabs example">
          {
            pageTabs.length && pageTabs.map((tab, index) => (
              <Tab key={index} label={tab} />
            ))
          }
        </Tabs>
      </Box>
      <Box sx={{ width: '100%', p: 2, color: theme.palette.color50555b.main }} className="corp-waterline-container">
        {
          tabPages.length && tabPages.filter((page, index) => index === tabIndex)
        }
      </Box>
    </>
  )
}

export default WaterlineManagement
